export function throttle<T extends (...args: any[]) => void>(func: T, delay: number): T {
    let isTimer: boolean;

    return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        const context = this;
        if (!isTimer) {
            func.apply(context, args);
            isTimer = true;
            setTimeout(() => isTimer = false, delay)
        }
    } as T;

}

export function debounce<T extends (...args: any[]) => void>(func: T, delay: number): T {
    let timeout: ReturnType<typeof setTimeout>;

    return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), delay)
    } as T;

}